import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { XCircle, RefreshCw, Home, MessageCircle } from 'lucide-react';

const PaymentFailed: React.FC = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/');
  };

  const handleHome = () => {
    navigate('/');
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/919876543210?text=Hi, I faced an issue with my payment for Toppers Notes', '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Payment Failed - TOPPERS BUDDY</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="flex min-h-screen items-center justify-center bg-background p-4">
        <Card className="w-full max-w-md border-destructive/30 shadow-xl">
          <CardHeader className="text-center pb-4">
            <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10">
              <XCircle className="h-12 w-12 text-destructive" />
            </div>
            <CardTitle className="text-2xl font-bold text-destructive">Payment Failed</CardTitle>
            <CardDescription className="text-base mt-2">
              Your payment could not be completed. Don't worry, no amount has been deducted.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="bg-muted/50 rounded-lg p-4 text-sm text-muted-foreground">
              <p className="font-medium mb-2">This could happen due to:</p>
              <ul className="list-disc list-inside space-y-1">
                <li>Payment was cancelled</li>
                <li>Insufficient balance</li>
                <li>Bank declined the transaction</li>
                <li>Network or timeout issue</li>
              </ul>
            </div>

            <Button onClick={handleRetry} className="w-full h-12 text-base" size="lg">
              <RefreshCw className="mr-2 h-5 w-5" />
              Try Again
            </Button>

            <Button onClick={handleHome} variant="outline" className="w-full h-12 text-base" size="lg">
              <Home className="mr-2 h-5 w-5" />
              Go to Home
            </Button>

            <div className="text-center pt-2">
              <p className="text-sm text-muted-foreground mb-2">Need help?</p>
              <Button onClick={handleWhatsApp} variant="ghost" className="text-green-600 hover:text-green-700">
                <MessageCircle className="mr-2 h-4 w-4" />
                Contact us on WhatsApp
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default PaymentFailed;
